module.exports = __webpack_public_path__ + "img/woori_card_banner.83868881.png";